import React from "react";
import { ShieldCheck } from "lucide-react";

/**
 * Positive trust badge shown on clinical detail pages once a clinician has
 * reviewed & approved the (AI-drafted) content. Renders nothing while pending —
 * the GuidelineReviewNotice already carries the reference-only disclaimer.
 */
export default function ReviewStatusBadge({ status, reviewedAt }) {
  if (status !== "approved") return null;
  const date = reviewedAt
    ? new Date(reviewedAt).toLocaleDateString("en-ZA", { year: "numeric", month: "short", day: "numeric" })
    : null;
  return (
    <span
      data-testid="clinician-approved-badge"
      className="inline-flex items-center gap-1 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-800 text-xs font-medium px-2.5 py-1"
    >
      <ShieldCheck className="w-3.5 h-3.5" />
      Clinician-approved{date ? ` · ${date}` : ""}
    </span>
  );
}
